/**
 * Desktop ilova (live web) — veb yangilanganda avtomatik qayta yuklash.
 * Qo‘lda .exe qayta o‘rnatish shart emas.
 */

const STORAGE_KEY = 'adde_web_build_version_v1';
const POLL_MS = 5 * 60 * 1000;

function isDesktopRuntime(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /addedesktop/i.test(String(navigator.userAgent || ''));
}

async function fetchWebBuildVersion(): Promise<string | null> {
  try {
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    if (!origin || origin === 'null' || origin.startsWith('file:')) return null;
    const url = `${origin.replace(/\/$/, '')}/web-build.json?t=${Date.now()}`;
    const res = await fetch(url, { cache: 'no-store', credentials: 'same-origin' });
    if (!res.ok) return null;
    const json = await res.json();
    const v = String(json?.version ?? json?.data?.version ?? '').trim();
    return v || null;
  } catch {
    return null;
  }
}

async function applyReloadIfNeeded(remoteVersion: string): Promise<void> {
  let prev = '';
  try {
    prev = sessionStorage.getItem(STORAGE_KEY) || '';
  } catch {
    // ignore
  }
  if (!prev) {
    try {
      sessionStorage.setItem(STORAGE_KEY, remoteVersion);
    } catch {
      // ignore
    }
    return;
  }
  if (prev === remoteVersion) return;

  const desktop = (window as { addeDesktop?: { reloadWeb?: () => Promise<unknown> } }).addeDesktop;
  if (desktop?.reloadWeb) {
    try {
      await desktop.reloadWeb();
    } catch {
      window.location.reload();
    }
  } else {
    window.location.reload();
  }
  try {
    sessionStorage.setItem(STORAGE_KEY, remoteVersion);
  } catch {
    // ignore
  }
}

async function pollOnce(): Promise<void> {
  const version = await fetchWebBuildVersion();
  if (!version || version === 'dev') return;
  await applyReloadIfNeeded(version);
}

/** Desktop + HTTPS/file emas — faqat production veb manzilda. */
export function startDesktopWebAutoUpdate(): void {
  if (typeof window === 'undefined' || !isDesktopRuntime()) return;
  void pollOnce();
  window.setInterval(() => {
    void pollOnce();
  }, POLL_MS);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') void pollOnce();
  });
}
